import MetricsProvider from "./MetricsProvider";

export default class Mixpanel extends MetricsProvider {
  appId;

  constructor(appId) {
    super();
    this.appId = appId;
  }

  identify(userIdentity, userProps) {
    mixpanel.identify(userIdentity);
    mixpanel.people.set(userProps);
  }

  install = () => {
    return import("./mixpanel.installer").then(() => {
      mixpanel.init(this.appId, {batch_requests: true});
    })
  }
  recordEvent(name, properties) {
    mixpanel.track(name, properties);
  }
}

